import { Api } from "../../api/Api";
import { BooleanThunk } from "../IStore";
import { thunkCreateErrorNotification } from "./NotificationActions";

export const GET_CUSTOMER_IDENTIFICATIONS = "GET_CUSTOMER_IDENTIFICATIONS";
export const GET_CUSTOMER_CUSTOM_FIELDS = "GET_CUSTOMER_CUSTOM_FIELDS";

export const thunkGetCustomerIdentifications =
  (customerNumber: string): BooleanThunk =>
  async (dispatch) => {
    try {
      const identifications = await Api.getCustomerIdentifications(customerNumber);
      dispatch({
        type: GET_CUSTOMER_IDENTIFICATIONS,
        payload: identifications,
      });
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to load customer passes", e));
      return false;
    }
  };
